import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './delete-social-account-modal.html';
import { SocialNetworks } from '../../forms/social-networks/social-networks';
import { MySiteApp } from '../../my-site-app';

/**
 * @customElement
 * @polymer
 */
export class DeleteSocialAccountModal extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
    }
  
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'delete-social-account-modal';
    }

    confirm() {
        let parent = document.querySelector(MySiteApp.is);
        parent.$.mySiteSidebarWrapper.querySelector(SocialNetworks.is).dispatchEvent(new CustomEvent('delete-social-account-modal-confirmation', {
            detail: this.data
        }));
        this.toggle();
    }

    toggle(e) {
        this.data = e;
        this.$.modalContainer.toggle();
    }

}

window.customElements.define(DeleteSocialAccountModal.is, DeleteSocialAccountModal);
